import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { onError } from '@apollo/client/link/error';
import { CombinedGraphQLErrors } from '@apollo/client/errors';

/**
 * Apollo error link shared by every named/default GraphQL client. Any resolver across any app
 * schema can throw a GraphQLException with extensions.code "MFA_REQUIRED" (see
 * PermissionMiddleware.EnforceMfaGateAsync in the GraphQL backend) - this catches that
 * consistently, regardless of which page/service triggered the call, and redirects to the MFA
 * challenge page instead of leaving the caller to handle a cryptic GraphQL error.
 */
export function createMfaRedirectErrorLink() {
  const router = inject(Router);

  return onError(({ error, operation }) => {
    const mfaRequired =
      CombinedGraphQLErrors.is(error) &&
      error.errors.some((graphQLError) => (graphQLError.extensions as { code?: string } | undefined)?.code === 'MFA_REQUIRED');

    if (mfaRequired && !router.url.startsWith('/mfa')) {
      console.warn(
        `[MFA] Received MFA_REQUIRED from operation "${operation.operationName}" while on "${router.url}" - redirecting back to /mfa.`,
      );
      router.navigate(['/mfa'], { queryParams: { returnUrl: router.url } });
    }
  });
}
